<div class="flex justify-between p-6 border-b border-[#E7EAF0]">
    <p class="text-[1.125rem] text-[#0A0A0A] font-semibold">Manage Group</p>
    <button type="button" (click)="onCancel()">
        <img class="h-5 w-5" src="/assets/images/auth/cross.svg" alt="Close" />
    </button>
</div>

<div class="px-6 py-4">
    <div class="flex w-fit items-center bg-[#f1f5f9] p-1 rounded-full">
        <p
            class="flex items-center justify-center px-4 py-1.5 text-[0.875rem] text-center text-[#0A0A0A] font-medium rounded-full cursor-pointer"
            [ngClass]="selectedTab === 'Details' ? 'bg-white' : ''"
            (click)="onTabSelect('Details')">
            Group Details
        </p>

        <p
            class="flex items-center justify-center px-4 py-1.5 text-[0.875rem] text-center text-[#0A0A0A] font-medium rounded-full cursor-pointer"
            [ngClass]="selectedTab === 'Manage' ? 'bg-white' : ''"
            (click)="onTabSelect('Manage')">
            Manage Members
        </p>

        <p
            class="flex items-center justify-center px-4 py-1.5 text-[0.875rem] text-center text-[#0A0A0A] font-medium rounded-full cursor-pointer"
            [ngClass]="selectedTab === 'Invite' ? 'bg-white' : ''"
            (click)="onTabSelect('Invite')">
            Invite Members
        </p>
    </div>
</div>

@if (selectedTab === 'Details') {
    <form [formGroup]="editForm" (ngSubmit)="submit()">
        <div class="flex flex-col px-6 py-4 gap-6 border border-[#E7EAF0] max-h-[60vh] overflow-y-auto">
            <p class="text-[1.125rem] text-[#0A0A0A] font-semibold">Group Settings</p>
            <!-- Cover Image -->
            <div>
                <label class="block text-[#0A0A0A] text-sm font-medium mb-2" for="photo">Cover Image</label>
                <div class="flex items-center space-x-6">
                    @if (coverImageUrl() !== ' ' && coverImageUrl()) {
                        <img
                            class="w-32 h-20 rounded-2xl object-cover border border-[#e7eaf0]"
                            alt="Cover"
                            [src]="coverImageUrl()" />
                    } @else {
                        <div
                            class="w-32 h-20 rounded-2xl border border-[#e7eaf0] bg-[#F3F3F5] text-[#0A0A0A] flex items-center justify-center font-normal text-[1.25rem]">
                            {{ editForm.get('name')?.value?.charAt(0) | uppercase }}
                        </div>
                    }
                    <input #fileInput type="file" accept="image/*" class="hidden" (change)="onFileSelected($event)" />
                    <button
                        type="button"
                        class="white-border-button sm:p-3 p-2 mb-1 sm:space-x-2 space-x-1 flex items-center h-fit"
                        (click)="fileInput.click()">
                        <img alt="Change Photo" class="h-5 w-5" src="/assets/images/shared/camera-icon.svg" />
                        <p class="text-[#4F66FF] whitespace-nowrap">Change Cover</p>
                    </button>
                </div>
            </div>
            <!-- Group Name -->
            <div>
                <label class="block text-[#0A0A0A] text-sm font-medium mb-2" for="name">Group Name</label>
                <input
                    id="name"
                    type="text"
                    formControlName="name"
                    class="w-full rounded-xl bg-[#F3F3F5] px-4 py-3 outline-none"
                    placeholder="Enter group name" />
                <!-- Error message -->
                @if (editForm.get('name')?.invalid && editForm.get('name')?.touched) {
                    <div class="text-red-500 text-xs mt-1">Please enter a group name.</div>
                }
            </div>
            <!-- Description -->
            <div>
                <label class="block text-[#0A0A0A] text-sm font-medium mb-2" for="description">Description</label>
                <textarea
                    id="description"
                    rows="4"
                    maxlength="300"
                    formControlName="description"
                    class="w-full rounded-xl bg-[#F3F3F5] px-4 py-3 outline-none resize-none"
                    placeholder="Tell us about your goup..."></textarea>
                <div class="flex mt-1">
                    @if (editForm.get('description')?.invalid && editForm.get('description')?.touched) {
                        <p class="text-red-500 text-xs">Please enter group description.</p>
                    }
                    <p class="text-xs text-[#717182] ml-auto">
                        {{ editForm.get('description')?.value?.length || 0 }}/300 characters
                    </p>
                </div>
            </div>
            <!-- Categories -->
            <div>
                <label class="block text-[#0A0A0A] text-sm font-medium mb-2" for="cats">Categories:</label>
                <div class="flex flex-wrap gap-2 mb-3">
                    @for (category of selectedGroupCategories(); track category.id) {
                        <p class="px-3 py-1 rounded-full border text-[0.8rem] font-medium inactive-tag">
                            {{ category.name }}
                        </p>
                    }
                </div>
                <div>
                    <!-- Category search -->
                    <div class="relative mb-3">
                        <img
                            src="/assets/images/shared/search-icon.svg"
                            alt="Search"
                            class="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-auto" />
                        <input
                            id="categorySearchInput"
                            type="text"
                            placeholder="Search group categories"
                            class="w-full pl-9 pr-3 py-2 border border-[#E7EAF0] rounded-xl text-sm focus:outline-none"
                            (input)="onCategorySearchInput($event.target.value)" />
                    </div>
                    <div class="flex flex-wrap gap-2">
                        @for (category of groupCategories(); track category.id) {
                            <button
                                type="button"
                                class="px-3 py-1 rounded-full border text-[0.8rem] font-medium transition duration-150"
                                [ngClass]="isCategorySelected(category) ? 'active-tag' : 'inactive-tag'"
                                (click)="toggleCategory(category)">
                                {{ category.name }}
                            </button>
                        }
                    </div>
                </div>
            </div>
        </div>

        <mat-dialog-actions>
            <button
                type="submit"
                class="border-button sm:py-3 px-6 p-2 sm:space-x-2 space-x-1 h-fit rounded-full bg-[#0047ff]">
                <img src="/assets/images/shared/save.svg" alt="Save" class="size-4" />
                <p class="whitespace-nowrap">Save Changes</p>
            </button>
        </mat-dialog-actions>
    </form>
}

@if (selectedTab === 'Manage') {
    <div
        class="flex flex-col px-6 py-4 gap-6 border border-[#E7EAF0] max-h-[60vh] overflow-y-auto popup-scrollable-member">
        <div class="flex flex-col">
            <p class="text-[1.125rem] text-[#0A0A0A] font-semibold">Member Requests</p>
            <p class="text-[#717182] text-sm">{{ totalMemberJoinRequests() }} members waiting for approval</p>
            @if (isJoinRequestsLoading()) {
                <div class="mt-5">
                    <app-people-skeleton></app-people-skeleton>
                    <app-people-skeleton></app-people-skeleton>
                    <app-people-skeleton></app-people-skeleton>
                </div>
            } @else if (memberJoinRequestsData().length !== 0) {
                <div class="flex flex-col gap-3 mt-5">
                    @for (item of memberJoinRequestsData(); track $index) {
                        <app-people
                            [people]="item"
                            [isGroupMember]="false"
                            [isJoinRequest]="true"
                            [isAdminModerator]="true"></app-people>
                    }
                </div>
            }
        </div>

        <div class="flex flex-col">
            <p class="text-[1.125rem] text-[#0A0A0A] font-semibold">View All Members</p>
            <p class="text-[#717182] text-sm">{{ totalMembers() }} members in this group</p>
            @if (isInitialLoading()) {
                <div class="mt-5">
                    <app-people-skeleton></app-people-skeleton>
                    <app-people-skeleton></app-people-skeleton>
                    <app-people-skeleton></app-people-skeleton>
                </div>
            } @else if (membersData().length !== 0) {
                <div
                    class="mt-5"
                    infiniteScroll
                    [infiniteScrollContainer]="'.popup-scrollable-member'"
                    [fromRoot]="true"
                    [infiniteScrollDistance]="1"
                    (scrolled)="onScrollManageGroup()">
                    <div class="flex flex-col gap-3">
                        @for (item of membersData(); track $index) {
                            <app-people [people]="item" [isGroupMember]="true" [isAdminModerator]="true"></app-people>
                        }
                    </div>
                </div>
            } @else {
                <div class="text-center text-[#717182] py-10">No members found</div>
            }
        </div>
    </div>
}

@if (selectedTab === 'Invite') {
    <div class="flex flex-col px-6 py-4 gap-6 border border-[#E7EAF0] max-h-[60vh]">
        <div class="flex flex-col">
            <p class="text-[1.125rem] text-[#0A0A0A] font-bold">Gather your friends</p>
            <p class="text-[#717182] text-sm">Invite others to share in this community.</p>
            <div class="p-3 rounded-2xl border border-[#E7EAF0] my-3">
                <div class="flex gap-3">
                    <img class="w-auto max-h-16 h-auto rounded-lg" alt="GroupIcon" [src]="groupData().photo" />
                    <div class="space-y-1">
                        <div class="flex items-center gap-3">
                            <p class="text-[#0F172A] font-semibold text-sm">{{ groupData().name }}</p>
                            <div class="flex items-center gap-1">
                                <img
                                    alt="Privacy"
                                    class="h-3 w-3"
                                    [src]="
                                        groupData().privacy === PrivacyTypeEnum.Public
                                            ? '/assets/images/post/public-icon.svg'
                                            : groupData().privacy === PrivacyTypeEnum.Private
                                              ? '/assets/images/post/anonymous-icon.svg'
                                              : '/assets/images/post/friends-icon.svg'
                                    " />
                                <p class="text-[#475569] text-xs">
                                    {{ getPrivacyTypeLabel(groupData().privacy) }}
                                </p>
                            </div>
                        </div>

                        <p class="text-[#475569] text-xs">{{ groupData().description }}</p>
                        <div class="flex items-center gap-4">
                            @if (groupData().cats && groupData().cats.length !== 0) {
                                <div class="flex flex-wrap gap-2">
                                    @for (tag of groupData().cats; track tag.id) {
                                        <div
                                            class="px-3 py-1 rounded-full bg-white border border-[#e7eaf0] text-[#0a0a0a] text-[0.8rem] font-medium transition duration-150">
                                            {{ tag.name }}
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <p class="text-sm font-semibold text-[#0A0A0A]">Invite Member</p>
            <div class="relative mt-3">
                <img
                    src="/assets/images/shared/search-icon.svg"
                    alt="Toggle password visibility"
                    class="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-auto" />
                <input
                    id="searchInput"
                    type="text"
                    placeholder="Search for Users"
                    class="w-full search-form-field-container rounded-2xl"
                    (input)="onUserSearchInput($event.target.value)" />
            </div>
            <div class="flex flex-col mt-3 pr-3 max-h-[25vh] overflow-y-auto popup-scrollable-user">
                @if (isInitialLoading()) {
                    @for (i of [1, 2, 3]; track i) {
                        <div class="flex items-center p-3">
                            <ngx-skeleton-loader appearance="circle" [theme]="{ width: '48px', height: '48px' }">
                            </ngx-skeleton-loader>

                            <ngx-skeleton-loader class="w-40 h-4 rounded-md ml-4"></ngx-skeleton-loader>
                        </div>
                    }
                } @else if (usersData().length !== 0) {
                    <div
                        class="flex flex-col p-3 gap-3"
                        infiniteScroll
                        [infiniteScrollContainer]="'.popup-scrollable-user'"
                        [fromRoot]="true"
                        [infiniteScrollDistance]="1"
                        (scrolled)="onScrollInviteMember()">
                        @for (item of usersData(); track item.id) {
                            <div class="flex justify-between items-center">
                                <div class="flex items-center">
                                    @if (item?.photo !== ' ' && item?.photo) {
                                        <img
                                            class="h-12 w-12 rounded-full object-cover border border-[#e7eaf0]"
                                            alt="Profile"
                                            [src]="item?.photo" />
                                    } @else {
                                        <div
                                            class="h-12 w-12 rounded-full border border-[#e7eaf0] bg-[#4F66FF] text-white flex items-center justify-center font-bold text-[1.2rem]">
                                            {{ item?.name?.charAt(0) | uppercase }}
                                        </div>
                                    }
                                    <p class="text-[#0A0A0A] font-medium ml-4">{{ item.name }}</p>
                                </div>
                                <input
                                    type="checkbox"
                                    class="checkbox-button"
                                    [checked]="selectedUsers().includes(item.id)"
                                    (change)="toggleUser(item.id, $event.target.checked)" />
                            </div>
                        }
                    </div>
                } @else {
                    <div class="text-center text-[#717182] py-10">No users found</div>
                }
            </div>
        </div>
    </div>
    <mat-dialog-actions>
        <button
            type="button"
            class="border-button sm:py-3 px-6 p-2 rounded-full bg-[#0047ff] min-w-28"
            [disabled]="selectedUsers().length === 0"
            (click)="inviteSelectedUsers()">
            Invite
        </button>
    </mat-dialog-actions>
}
